import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import styles from './ContentOverviewAuthors.module.css';

type ContentOverviewAuthorsProps = ComponentProps & {
	fields: {
		AuthorsTitle: Field<string>;
		ProfessionalLeads: Field<string>;
	};
};

type authorObjectType = {
	authorName: string;
	authorDescription: string;
};

export default function ContentOverviewAuthors(props: ContentOverviewAuthorsProps): JSX.Element {
	if (!props.fields.ProfessionalLeads || props.fields.ProfessionalLeads.value.trim() === '') {
		return <></>;
	}

	const authorObjectArray: authorObjectType[] = [];

	const authorsArray = props.fields.ProfessionalLeads.value.split('<br />').filter((author) => {
		return author.replace(/(<([^>]+)>)/gi, '').trim() != '';
	});

	authorsArray.map((authorNameAndDescription) => {
		/**
		 * spitNameFromDescription uses richtext field styling of bold author
		 * name followed by description to split out the author names and descriptions
		 * **/
		const splitNameFromDescription = authorNameAndDescription.includes('</b>')
			? authorNameAndDescription.split('</b>')
			: authorNameAndDescription.split('</strong>');

		const authorObject: authorObjectType = {
			// authorObject strips richtext field of html and replaces html entities to produce clean authorNames and Descriptions
			authorName: splitNameFromDescription[0].replace(/(<([^>]+)>)/gi, '').trim(),
			authorDescription: splitNameFromDescription[1]
				.replace(/(<([^>]+)>)/gi, '')
				.replace('(', '')
				.slice(0, -1)
				.trim(),
		};
		authorObject.authorName != '' && authorObjectArray.push(authorObject);
	});

	return (
		<div>
			<ContentOverviewHeaderContainer header={props.fields.AuthorsTitle?.value} />
			<div className={styles.authorsContainer}>
				{authorObjectArray.map((author, index) => (
					<div key={index} className={styles.authorItem}>
						<h4 className={styles.authorName}>{author.authorName}</h4>
						<p className={styles.authorDescription}>{author.authorDescription}</p>
					</div>
				))}
			</div>
		</div>
	);
}
